import React, { Component, ElementType } from "react";
import { connect } from "react-redux";
import * as actions from "../../../actions";
import {
  ProductType,
  UpdateProductsListAction,
  IUpdateManyProdsWithOneRedir,
  RedirectionWithProducts as RedirectionWithProductsData,
} from "../../../actions";
import { StoreState } from "../../../reducers";
import { by } from "../../../utils/by";
import requireAuth from "../../requireAuth";
import "./RedirectionWithProductsStyle.scss";
import ReactPaginate from "react-paginate";
import {itemsPerPage} from "../../../config";

interface IRedirectionWithProductsProps {
  errorMessage: string;
  redirectionId: string;
  products: ProductType[];
  filteredProducts: ProductType[];
  initRedirection: { description?: string };
  prodsWithThisRedir: ProductType[];
  backToRedirectionsList: () => void;
  startAddingProductsToRedirection: (_id: string) => Promise<RedirectionWithProductsData | undefined>;
  updateProductsList: (products: ProductType[]) => UpdateProductsListAction;
  updateManyProdsWithOneRedir: ({
    redirectionId,
    productListWithDots,
  }: IUpdateManyProdsWithOneRedir) => void;
  getProducts: (page?: number, search?: string) => void;
  allProductsCount?: number;
}

interface IProductsListState {
  page: number;
  searchText?: string;
  selectedProducts: Record<string, boolean>;
}

class RedirectionWithProducts extends Component<
  IRedirectionWithProductsProps, IProductsListState
> {
  constructor(props: IRedirectionWithProductsProps) {
    super(props);
    this.state = { page: 1, selectedProducts: {} };
  }

  async componentDidMount() {
    const { startAddingProductsToRedirection, redirectionId } = this.props;
    const data = await startAddingProductsToRedirection(redirectionId);
    if (data && data.prodsWithThisRedir) {
      const selected: Record<string, boolean> = {};
      data.prodsWithThisRedir.forEach((product) => {
        if (product.partNumber) {
          selected[product.partNumber] = true;
        }
      });
      this.setState({ selectedProducts: selected });
    }
    this.getProductsList();
  }

  handlePageClick(event: any) {
    if (event.nextSelectedPage === undefined) return;
    this.setState({ page: event.nextSelectedPage + 1 }, () => {
      this.getProductsList();
    });
  }

  async getProductsList() {
    await this.props.getProducts(this.state.page, this.state.searchText);
    await this.props.updateProductsList(this.props.products);
  }

  filterProducts(e?: React.FormEvent<HTMLInputElement>) {
    const searchText = e ? e.currentTarget.value : "";
    this.setState({page: 1, searchText}, () => {
      this.getProductsList();
    });
  }

  handleCheckboxChange = (partNumber: string, checked: boolean) => {
    this.setState((prevState) => ({
      selectedProducts: {
        ...prevState.selectedProducts,
        [partNumber]: checked,
      },
    }));
  };

  renderProductsList() {
    const { filteredProducts } = this.props;
    const { selectedProducts } = this.state;
    if (filteredProducts) {
      return filteredProducts.sort(by("partNumber")).map((product) => {
        const { partNumber } = product;
        return (
          <div className="checkbox" key={partNumber}>
            <label className="switch  switch__flex">
              <input
                type="checkbox"
                checked={!!selectedProducts[partNumber]}
                onChange={(e) => this.handleCheckboxChange(partNumber, e.target.checked)}
              />
              <span></span>
              {partNumber}
            </label>
          </div>
        );
      });
    }
  }

  onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { redirectionId, updateManyProdsWithOneRedir } = this.props;
    const { selectedProducts } = this.state;

    const productListWithDots = Object.keys(selectedProducts).filter(
      (key) => selectedProducts[key]
    );
    updateManyProdsWithOneRedir({ redirectionId, productListWithDots });
  };

  handleToggleVisible = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { filteredProducts } = this.props;
    const checked = e.target.checked;
    this.setState((prevState) => {
      const updated = { ...prevState.selectedProducts };
      if (filteredProducts) {
        filteredProducts.forEach((product) => {
          if (product.partNumber) {
            updated[product.partNumber] = checked;
          }
        });
      }
      return { selectedProducts: updated };
    });
  };

  renderAlert() {
    if (this.props.errorMessage) {
      return <div className="alert__message">{this.props.errorMessage}</div>;
    }
  }

  render() {
    const { initRedirection } = this.props;
    const pageCount = this.props.allProductsCount ? Math.ceil(this.props.allProductsCount / itemsPerPage) : 0;
    return (
      <div className="redir-with-prods-page">
        <h1 className="redir-with-prods-page__title">
          {initRedirection.description}
        </h1>
        <div className="redir-with-prods-page__subheader">
          <label className="switch  switch__flex switch__flex__label">
            <input type="checkbox" onChange={this.handleToggleVisible} />
            <span></span>select all visible
          </label>
          <div className="selectable-products-list__filter">
            <label className="selectable-products-list__filter__label">
              filter
            </label>
            <input
              className="selectable-products-list__filter__input"
              placeholder="search..."
              onChange={(e) => {
                this.filterProducts(e);
              }}
            />
          </div>
        </div>
        <form
          className="selectable-products-form "
          onSubmit={this.onSubmit}
        >
          <div className="selectable-products-list">
            {this.renderProductsList()}
          </div>
          <div className="alert">{this.renderAlert()}</div>
          { pageCount > 1 && <ReactPaginate
              className="pagination"
              pageCount={pageCount}
              forcePage={this.state.page - 1}
              onClick={(e) => {
                this.handlePageClick(e);
              }}
          />}
          <div className="order-buttons">
            <div className="order-buttons__row order-buttons__row--wide">
              <button
                className="btn btn--finish btn--accent "
                type="button"
                onClick={() => {
                  this.props.backToRedirectionsList();
                }}
              >
                {"<< back"}
              </button>
              <button
                className="btn btn--accent "
                type="submit"
              >
                SAVE
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state: StoreState) {
  const {
    errorMessage,
    redirectionId,
    initRedirection,
    prodsWithThisRedir,
    filteredProducts,
    products,
    allProductsCount,
  } = state.wids;
  return {
    errorMessage,
    redirectionId,
    products,
    allProductsCount,
    filteredProducts,
    initRedirection,
    prodsWithThisRedir,
  };
}

export default connect(
  mapStateToProps,
  actions
)(requireAuth(RedirectionWithProducts)) as ElementType;
